import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Wrapper from './Wrapper';
import CustomSelect from 'Common/CustomSelect';
import { STATUS_ACTIVE, STATUS_INACTIVE } from 'Constants';

const statuses = [
    {value: STATUS_ACTIVE, label: <FormattedMessage id="types.status.active"/>},
    {value: STATUS_INACTIVE, label: <FormattedMessage id="types.status.inactive"/>},
];

function StatusSelect(props) {
    const { value } = props;

    return <CustomSelect {...props} options={statuses} value={value ? STATUS_ACTIVE : STATUS_INACTIVE}/>;
}

StatusSelect.propTypes = {
    value: PropTypes.any
};

export default function FormStatusSelect(props) {
    return <Wrapper {...props} InputComponent={StatusSelect}/>;
}



// WEBPACK FOOTER //
// ./src/common/ReduxForm/FormStatusSelect.jsx